import { useEffect, useState, useRef } from "react";
import {
  collection,
  getDocs,
  doc,
  getDoc,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase-config";
import BarraNavegacion from "../components/BarraNavegacion";
import { Container } from "react-bootstrap";
import EstadoTransaccion from "../components/EstadoTransaccion";
import PasoProgressBar from "../components/PasoProgressBar";

function ConfirmacionPago() {
  const [NumeroTickets, setNumeroTickets] = useState(0);
  const [UsuarioIG, setUsuarioIG] = useState("");
  const [Correo, setCorreo] = useState("");
  const [Fecha, setFecha] = useState("");
  const [referecia, setReferencia] = useState("");
  const [valor, setValor] = useState("");
  const [nombres, setNombres] = useState("");
  const [cantidad, setCantidad] = useState("");
  const [transactionEstate, setTransactionEstate] = useState("");
  const [metodoPago, setMetodoPago] = useState("");
  const [NumerosAsignados, setNumerosAsignados] = useState([]);
  const [numerosPremiados, setNumerosPremiados] = useState([]);
  const [cifrasSorteo, setCifrasSorteo] = useState(0);
  const [loading, setLoading] = useState(true);
  const effectExecuted = useRef(false);

  /** 🔥 Verifica el pago y obtiene los tickets desde Firestore **/
  useEffect(() => {
    if (effectExecuted.current) return;
    effectExecuted.current = true;

    const searchParams = new URLSearchParams(window.location.search);
    const transactionId =
      localStorage.getItem("transactionId") ||
      searchParams.get("external_reference") ||
      searchParams.get("id");

    if (!transactionId) {
      setTransactionEstate("No encontrada");
      setLoading(false);
      return;
    }

    const maxRetries = 20;
    const delay = 1500; // ms
    let retries = 0;

    const manejarEstadoSegunStatus = (status) => {
      if (status === "APPROVED") {
        setTransactionEstate("Aceptada");
      } else if (status === "PENDING") {
        setTransactionEstate("Pendiente");
      } else if (status === "REJECTED") {
        setTransactionEstate("Cancelada");
      } else {
        setTransactionEstate("Desconocido");
      }
    };

    const checkPaymentStatus = async () => {
      try {
        const transactionRef = doc(db, "transacciones", transactionId);
        const transactionSnap = await getDoc(transactionRef);

        if (!transactionSnap.exists()) {
          setTransactionEstate("No encontrada");
          setLoading(false);
          return;
        }

        const transactionData = transactionSnap.data();

        // Validar si está listo (solo si fue aprobado y tiene tickets)
        const isReady =
          transactionData.status === "APPROVED" &&
          Array.isArray(transactionData.tickets) &&
          transactionData.tickets.length > 0;

        if (!isReady && retries < maxRetries) {
          retries++;
          console.log(
            `🔁 Intento ${retries} esperando datos de transacción...`
          );
          setTimeout(checkPaymentStatus, delay);
          return;
        }

        // Asignar datos generales
        setCorreo(transactionData.Correo);
        setUsuarioIG(transactionData.Instagram);
        setFecha(transactionData.Fecha);
        setReferencia(transactionData.transactionId);
        setNombres(transactionData.Nombres);
        setCantidad(transactionData.Cantidad);
        setValor(transactionData.Valor);
        setMetodoPago(transactionData.metodo_pago);

        if (!transactionData.idSorteo) {
          console.error("⚠️ idSorteo no está definido en la transacción.");
          setTransactionEstate("Error");
          setLoading(false);
          return;
        }

        const sorteoRef = doc(db, "sorteos", transactionData.idSorteo);
        const sorteoSnap = await getDoc(sorteoRef);
        const sorteoData = sorteoSnap.exists() ? sorteoSnap.data() : {};
        setNumerosPremiados(
          Array.isArray(sorteoData.numerosPremiados)
            ? sorteoData.numerosPremiados
            : []
        );
        setCifrasSorteo(Number(sorteoData.cifras) || 0);

        // Validar tickets antes de hacer la consulta con 'in'
        if (
          Array.isArray(transactionData.tickets) &&
          transactionData.tickets.length > 0
        ) {
          const ticketsRef = collection(
            db,
            `sorteos/${transactionData.idSorteo}/tickets`
          );
          const chunkArray = (arr, size) => {
            const result = [];
            for (let i = 0; i < arr.length; i += size) {
              result.push(arr.slice(i, i + size));
            }
            return result;
          };

          const ticketsUsuario = [];

          const ticketChunks = chunkArray(transactionData.tickets, 30);

          for (const chunk of ticketChunks) {
            const q = query(ticketsRef, where("__name__", "in", chunk));
            const querySnapshot = await getDocs(q);

            querySnapshot.forEach((doc) => {
              if (
                doc.data().usuario.trim().toLowerCase() ===
                transactionData.Correo.trim().toLowerCase()
              ) {
                ticketsUsuario.push(doc.data().numero);
              }
            });
          }

          setNumerosAsignados(ticketsUsuario);
          setNumeroTickets(ticketsUsuario.length);
        } else {
          setNumeroTickets(0); // Para no mostrar card si no hay tickets
        }

        // Asignar estado final
        manejarEstadoSegunStatus(transactionData.status);
        setLoading(false);
      } catch (err) {
        console.error("Error verificando pago:", err);
        setTransactionEstate("Error");
        setNumeroTickets(0);
        setLoading(false);
      }
    };

    checkPaymentStatus();
    localStorage.removeItem("transactionId");
  }, []);

  return (
    <div>
      <BarraNavegacion />
      {loading ? (
        <div className="text-center">
          <PasoProgressBar estado={transactionEstate} />
          <p>Verificando pago...</p>
        </div>
      ) : (
        <>
          <Container></Container>

          {transactionEstate === "Aceptada" && NumeroTickets > 0 ? (
            <EstadoTransaccion
              transaccion={{
                estado: transactionEstate,
                correo: Correo,
                instagram: UsuarioIG,
                cantidad: cantidad,
                monto: parseInt(valor), // Asegúrate de que 'Monto' sea un número
                comprador: nombres,
                referencia: referecia,
                fecha: Fecha,
                medioPago: metodoPago,
                tickets: NumerosAsignados,
                numerosPremiados,
                cifras: cifrasSorteo,
              }}
            />
          ) : transactionEstate === "Cancelada" ||
            transactionEstate === "Pendiente" ? (
            <EstadoTransaccion
              transaccion={{
                estado: transactionEstate,
                correo: Correo,
                instagram: UsuarioIG,
                cantidad: cantidad,
                monto: parseInt(valor), // Asegúrate de que 'Monto' sea un número
                comprador: nombres,
                referencia: referecia,
                fecha: Fecha,
                medioPago: metodoPago,
              }}
            />
          ) : (
            <Container className="my-4">
              <div className="alert alert-warning text-center" role="alert">
                No se encontró información de la transacción. Si el pago fue
                aprobado, revisa tus tickets desde la sección Mis Tickets
                Comprados.
              </div>
            </Container>
          )}
        </>
      )}
    </div>
  );
}

export default ConfirmacionPago;
